import { config } from '@/config';
import {
    IRegistrationTemplateRequestParams,
    IRegistrationTemplateResponse,
    isObject,
} from '@/types';
import { getErrorMessage } from './getErrorMessage';
import { isNewErrorFormat } from './fetch';

export const getRegistrationTemplateData = async (
    params: Partial<IRegistrationTemplateRequestParams>,
) => {
    try {
        const queryParams = Object.entries(params)
            .filter(([, value]) => value)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

        if (!queryParams) return undefined;

        const url = `${config.api.url.registration}/template?${queryParams}`;

        const res = await fetch(url, { cache: 'no-store' });
        const json = (await res.json()) as Promise<IRegistrationTemplateResponse>;

        if (!isObject(json) || isNewErrorFormat(json)) return undefined;

        return json;
    } catch (err) {
        const errorMessage = `Error getting registration template data: ${getErrorMessage(err)}`;
        if (
            err &&
            isObject(err) &&
            'message' in err &&
            'name' in err &&
            err.name !== 'incorrect data'
        ) {
            err.message = errorMessage;
        }
        throw err;
    }
};
